/**
 * This file contains a nice way to prefix icons for use with font awesome
 *
 * @author Learning Technologies
 * @copyright Learning Technologies, University of Aberdeen
 */

window.FontAwesome = {

    /**
     * Prefixes a font awesome icon
     *
     * @param string icon type, regular or solid
     * @param string icon the icon to display
     * @param boolean spin turns icon spinning on and off
     *
     * @return string
     */
    prefix: function (type, icon, spin) {
        // eslint-disable-next-line no-extra-boolean-cast
        return 'fa-' + type + ' fa-' + icon + ' ' + (Boolean(spin) ? 'fa-spin' : '');
    },
};
